import React from 'react';
import Footer from 'bloomer/lib/layout/Footer';
import { Container } from 'bloomer/lib/layout/Container';
import { Content } from 'bloomer/lib/elements/Content';
import { Columns } from 'bloomer/lib/grid/Columns';
import { Column } from 'bloomer/lib/grid/Column';
import { Icon } from 'bloomer/lib/elements/Icon';

const AppFooter = () => (
  <Footer>
    <Container>
      <Content>
        <Columns>
          <Column>
            <p>
              Made with
              <Icon className="fa fa-heart" />
              by <a href="https://markwilkins.co">Mark Wilkins</a>
            </p>
          </Column>
        </Columns>
        <Content isSize="small">
          <p>Icons Created by "Px icon" from the Noun Project.</p>
          <p>Loading gears by loading.io.</p>
        </Content>
      </Content>
    </Container>
  </Footer>
);

export default AppFooter;
